// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CLtg","largestCol":"styles_largestCol__28qY2","smallestCol":"styles_smallestCol__2K9tI"};